export const getOrigin = (url: string) => {
  try {
    const { origin } = new URL(url);

    return origin;
  } catch (error) {
    return url;
  }
};
